// $('.product__media-list').bind('touchstart', function(){
// }).bind('touchend', function(){
//   setTimeout(function() {
//     $('.thumbnail-list .thumbnail[aria-current]').click();
//   }, 200);
// });



$(document).on("click",".product-with-dot-slides-inner-row .slider-button",function() {
  var active_dot = $(this).parents('slider-component').find('.slider-counter--dots .slider-counter__link--active');
  var dots = $(this).parents('slider-component').find('.slider-counter--dots .slider-counter__link--dots');
  
  if($(this).hasClass('slider-button--prev')){
    if($(active_dot).prev().length == 0){
      $($(dots)[$(dots).length-1]).click()
    }
  }else{
    if($(active_dot).next().length == 0){
      $($(dots)[0]).click()
    }
  }
});

$(document).ready(function() {
  $('.product-grid-container').addClass('active');
});

/* ------------------------------------------------------------------------------------------------
   UpCart: afbeelding van de add-on (Prio +) verbergen.
   UpCart rendert in een shadow DOM, dus de CSS wordt daar ingevoegd. Raakt de toggle zelf niet aan.
------------------------------------------------------------------------------------------------ */
(function () {
  var STYLE_ID = 'uc-addon-hide-image';
  var CSS = '.upcart-internal-addons__image-wrapper{display:none!important}';

  function inject() {
    var root = window.upcartDocumentOrShadowRoot;
    if (!root) return false;
    var target = root.nodeType === 11 ? root : document.head;
    if (!target.querySelector('#' + STYLE_ID)) {
      var style = document.createElement('style');
      style.id = STYLE_ID;
      style.textContent = CSS;
      target.appendChild(style);
    }
    return true;
  }

  var hooked = false;
  var ticks = 0;
  var poll = setInterval(function () {
    var done = inject();
    if (!hooked && typeof window.upcartSubscribeCartOpened === 'function') {
      hooked = true;
      window.upcartSubscribeCartOpened(inject);
    }
    if ((done && hooked) || ++ticks > 120) { clearInterval(poll); }
  }, 250);
})();
